import { core } from 'angular-ui-router';

/* @ngInject */
export default class BalanceSheetCtrl {
	constructor(
		$sce,
		$scope,
		$state,
		Utility,
		$timeout,
		$rootScope,
		BuildingsService,
		FinancialsService,
		LocalStorageService,
		BalanceSheetService,
		AuthorizationService
	) {
		this.$sce = $sce;
		this.$scope = $scope;
		this.$state = $state;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.BuildingsService = BuildingsService;
		this.FinancialsService = FinancialsService;
		this.LocalStorageService = LocalStorageService;
		this.BalanceSheetService = BalanceSheetService;
        this.AuthorizationService = AuthorizationService;
		this.init();
		this.activate();
	}

	init() {
		this.isFilterActive = true;
		this.reportModelHeader = '';
		this.filterYear = undefined;
		this.filterMonth = undefined;
		this.selectedBuildingRef = '';
		this.statusInformation = null;
		this.selectedBuildingName = '';
		this._switchIsBusyLoading(true);
		this.financialsServiceData = this.FinancialsService;
		this.today = this.Utility.getFormatedDate(new Date());

		this.stickableStyles = `
				top: -0.5em;
				left: 4.93em;
				width: 91.74%;
				z-index: 10;
				position: fixed;
				background-color: #e8e8e8;
			`;

		this.$scope.$on('selected-building-changed', async (event, newValue) => {
			await this.onSelectedBuildingChanged(this, newValue);
		});
	}

	async activate() {
		this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();

		let buildingName = '';
		const userProfile = this.LocalStorageService.retrieve('userProfile');

		if (userProfile) {
			if (!this.selectedBuildingRef) {
                this.selectedBuildingRef = userProfile.BuildingProfiles[0].SchemeReference;
            }
			const selectedBuilding = userProfile.BuildingProfiles.find((building) => {
				return building.SchemeReference.toUpperCase().trim() === this.selectedBuildingRef.toUpperCase().trim();
			});

			if (selectedBuilding) {
				buildingName = selectedBuilding.SchemeName;
			}
		}

		await this.getFinancialYears(true);
		this.selectedBuildingName = buildingName;
	}

	openFinancials(page) {
        this.saveSelectedDate();
        this.$rootScope.$broadcast('navigate-changed', page, { date: this.filterMonth });
    }

	saveSelectedDate() {
        const selectedYear = moment(this.filterYear).toDate();
        const selectedMonth = moment(this.filterMonth).add(3, 'h').toDate();
        this.LocalStorageService.save('selectedReportYear', selectedYear);
        this.LocalStorageService.save('selectedReportMonth', selectedMonth);
    }

	getAccountNameHtmlFromItem(item) {
		if (item.AccountCode == '30005' && item.AccountName.includes('(Loss)')) {
			const replacementString = '<span style="color:red">(Loss)</span>';
			const stringToReplace = '(Loss)';

			const accountname = item.AccountName.replace(stringToReplace, replacementString);

			return this.$sce.trustAsHtml(accountname);
		}

        return item.AccountName;
	}

    async gotoOldFinancials() {
        const date = moment(this.filterMonth).format('MMM YYYY');
        let nav = `Monthly Financial Statements>${date}`;
        nav = encodeURI(nav);
        this.$state.go('documents', { nav });
    }

	isDesktop() {
		this.LocalStorageService.save('mediaDevice', 'mobile');
		const mdvice = this.LocalStorageService.retrieve('mediaDevice');
		if (mdvice == 'mobile') {
			return true;
		}

		return false;
	}

	async filterByYear() {
		this.selectedDateYear = this.Utility.getFormatedDate(this.filterYear);
		await this.getBalanceSheet();
	}

	async getReport() {
		const date = this.Utility.getFormatedDate(this.filterYear);
		this.reportModelHeader = `${this.selectedBuildingName} - Balance Sheet - ${moment(date).format('MMM YYYY')}`;

		this._switchIsBusyLoading(true);
		try {
			await this.financialsServiceData.getReport(this.selectedBuildingRef, date, 2, this.reportModelHeader);
		} catch (err) {
			console.error('Error while generating Balance Sheet Report');
		} finally {
			this._switchIsBusyLoading(false);
		}
	}

	async onSelectedBuildingChanged(event, schemeRef) {
		if (schemeRef && schemeRef['length'] > 2) this.selectedBuildingRef = schemeRef;
		else this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();

		if (this.selectedBuildingRef && this.selectedBuildingRef.length > 2) {
			await this.activate();
		}
	}

    async getFinancialYears(isInit) {
        this._switchIsBusyLoading(true);

        try {
            await this.financialsServiceData.getFinancialYears(this.selectedBuildingRef, this.today);
            if (isInit) {
                await this.getSelectedDate(true);
            } else {
                this.filterYear = this.financialsServiceData.financialYears[
                    this.financialsServiceData.financialYears.length - 1
                ].WhenTo;
                this.selectedDateYear = this.Utility.getFormatedDate(this.filterYear);
                await this.getBalanceSheet();
            }
        } catch (err) {
            console.error(`Error while loading Financial Years.`);
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

	async getBalanceSheet() {
		this._switchIsBusyLoading(true);
		try {
			await this.BalanceSheetService.getBalanceSheet(
				this.selectedBuildingRef,
				this.Utility.getFormatedDate(this.filterYear)
			);
			await this.getFinancialState();
		} catch (err) {
			console.error(`Error loading Balance Sheet Data`);
		} finally {
			this._switchIsBusyLoading(false);
		}
	}

	async getSelectedDate(isInit) {
		const selectedDateYear = this.FinancialsService.getSelectedYear();
		if (isInit) {
			let index = 0;
			for (let i = 0; i < this.financialsServiceData.financialYears.length; i++) {
				const yearRaw = this.financialsServiceData.financialYears[i];

				if (selectedDateYear.isBetween(yearRaw.WhenFrom, yearRaw.WhenTo)) {
					index = i;
					this.filterYear = this.financialsServiceData.financialYears[i].WhenTo;
					this.selectedDateYear = this.Utility.getFormatedDate(this.filterYear);

					break;
				}
			}
			await this.getBalanceSheet();
		}
	}

	async getFinancialState() {
		const type = 2;
		const schemeRef = this.selectedBuildingRef;
		const momentDate = moment(this.selectedDateYear, 'YYYY-MM-DD');
		const formattedDate = momentDate.format('YYYY-MM-DD');
		const date = `${formattedDate.substr(0, 8)}01`;

		this._switchIsBusyLoading(true);
		try {
			const results = await this.FinancialsService.getFinancialState(schemeRef, date, type);

			const { status, message } = results;
			this.statusInformation = message;
		} catch (error) {
			this.NotificationService.error('Error loading balance sheet statement status');
		} finally {
			this._switchIsBusyLoading(false);
		}
	}

	allowAction(actionName) {
        return this.AuthorizationService.isAuthorized(actionName);
    }

	_switchIsBusyLoading(flag) {
		this.$timeout(() => {
			this.isLoading = flag;
		});
	}
}
